import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getMyShiftListPath, createMyShiftPath } from "../../services/config";
import { config } from "../../services/configHeader";

const user = localStorage.getItem("user_data")
  ? JSON.parse(localStorage.getItem("user_data"))
  : null;
const user_id = user?.user_id;
const accountType = user?.account_type;
const baseUrl = process.env.REACT_APP_BASE_URI;

const normalizeThunkError = (error, fallbackMessage = "Request failed") => ({
  status: error?.response?.status || error?.status || 500,
  response: {
    data: {
      ...(error?.response?.data || {}),
      message:
        error?.response?.data?.message ||
        error?.message ||
        fallbackMessage,
      data: error?.response?.data?.data || null,
    },
  },
  message: error?.message || fallbackMessage,
});

let initialState = {
  shiftLoading: false,
  shiftSuccess: false,
  shiftError: false,
  shiftMessage: null,

  shiftGetLoading: false,
  shiftGetSuccess: false,
  shiftGetError: false,
  shiftGetMessage: null,
  shiftGetData: null,
};


export const fetchData = createAsyncThunk("fetchData", async (userId) => {
  const userid = userId != undefined && userId != "" ? userId : user_id
  return await axios
    .get(`${baseUrl}${getMyShiftListPath}${userid}`, config)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      if (!navigator.onLine) {
        let data = {
          response: {
            data: [],
            message: "No Internet Connection Found",
            success: false,
          },
          data: {
            data: [],
            message: "No Internet Connection Found",
            success: false,
          },
        };
        return data;
      } else {
        return normalizeThunkError(error, "Failed to load shifts");
      }
    });
});

export const saveShift = createAsyncThunk("saveShift", async (data) => {
  const result = {
    data: {
      message: "Sorry, you can only view the data, not create it.",
      data: [],
    },
  };
  return parseInt(accountType) === 2
    ? result
    : await axios
        .post(`${baseUrl}${createMyShiftPath}`, data, config)
        .then((response) => {
          console.log(response)
          return response;
        })
        .catch((error) => {
          console.log(error)
          if (!navigator.onLine) {
            let data = {
              response: {
                data: [],
                message: "No Internet Connection Found",
                success: false,
              },
            };
            return data;
          } else {
            return normalizeThunkError(error, "Failed to save shift");
          }
        });
});

const shiftSlice = createSlice({
  name: "shift",
  initialState,

  reducers: {
    initState: (state) => {
      state.shiftLoading = false;
      state.shiftSuccess = false;
      state.shiftError = false;
      state.shiftMessage = null;

      state.shiftGetLoading = false;
      state.shiftGetSuccess = false;
      state.shiftGetError = false;
      state.shiftGetMessage = null;
    },

    initShiftState: (state) => {
      state.shiftLoading = false;
      state.shiftSuccess = false;
      state.shiftError = false;
      state.shiftMessage = null;

      state.shiftGetLoading = false;
      state.shiftGetSuccess = false;
      state.shiftGetError = false;
      state.shiftGetMessage = null;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(fetchData.pending, (state, action) => {
      state.shiftGetLoading = true;
      state.shiftGetSuccess = false;
      state.shiftGetError = false;
      state.shiftGetMessage = null;
      state.shiftGetData = null;
    });
builder.addCase(fetchData.fulfilled, (state, action) => {
  state.shiftGetLoading = false;
  state.shiftGetSuccess = true;
  state.shiftGetError = false;

  const payload = action.payload || {};

  state.shiftGetMessage =
    payload?.status === 200
      ? payload?.data?.message
      : payload?.response?.data?.message || "Something went wrong";

  state.shiftGetData =
    payload?.status === 200
      ? payload?.data?.data ?? []
      : payload?.response?.data?.data ?? [];
});

builder.addCase(fetchData.rejected, (state, action) => {
  state.shiftGetLoading = false;
  state.shiftGetSuccess = false;
  state.shiftGetError = true;
  state.shiftGetMessage =
    action.error?.message || "Failed to fetch shifts";
  state.shiftGetData = [];
});

    // To create branch
    builder.addCase(saveShift.pending, (state, action) => {
      state.shiftLoading = true;
      state.shiftSuccess = false;
      state.shiftError = false;
      state.shiftMessage = null;
    });
    builder.addCase(saveShift.fulfilled, (state, action) => {
      const payload = action.payload || {};
      const body = payload.data || {};
      const responseBody = payload.response?.data || {};
      const status = payload.status;
      if(status == 200 || status == 201 || status == "200" || status == "201"){
        if(body.status == true || body.status == "true"){
          state.shiftLoading = false;
          state.shiftSuccess = accountType == 2 ? false :  true;
          state.shiftError = accountType == 2 ? true :  false ;
          state.shiftMessage =  body.message || body.msg || null;
        }else{
          state.shiftLoading = false;
          state.shiftSuccess =  false;
          state.shiftError =  true ;
          state.shiftMessage =  body.msg || body.message || "Failed to save shift";
        }
      }
      else{
        state.shiftLoading = false;
        state.shiftSuccess = false;
        state.shiftError = true;
        state.shiftMessage = responseBody.message || body.message || body.msg || payload.message || "Failed to save shift";
      }
     
    });
    builder.addCase(saveShift.rejected, (state, action) => {
      state.shiftLoading = false;
      state.shiftSuccess = false;
      state.shiftError = true;
      state.shiftMessage = action.payload?.response?.data?.message || action.error?.message || "Failed to save shift";
    });
  },
});
export const { initState, initShiftState } = shiftSlice.actions;
export default shiftSlice.reducer;
